import request from '@/utils/request'
// import { session } from '@/utils/session'

let baseURL = '/uc';

//获取jsapi的config配置
export function getWxConfig(data) {
  return request({
    url: '/api/app/weixinmp/getjsapi',
    method: 'post',
    data,
    baseURL
  })
}

// 微信登录，获取code（第一步）
export function getRedirectUrl(data) {
  return request({
    url: '/api/app/weixinmp/redirectUrl',
    method: 'post',
    data,
    baseURL
  })
}


//获取微信用户信息（第二步）
export function getWeixinInfo(data) {
  return request({
    url: '/api/app/weixinmp/getWeixinInfo',
    method: 'post',
    baseURL,
    data
  })
}

//微信注册----不绑定手机号
export function wxRegister(data) {
  return request({
    url: '/api/auth/v3/user/wx/register',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
city (string, optional): 普通用户个人资料填写的城市 ,
country (string, optional): 国家，如中国为CN ,
headimgurl (string, optional): 用户头像，最后一个数值代表正方形头像大小（有0、46、64、96、132数值可选，0代表640*640正方形头像），用户没有头像时该项为空 ,
mobileNumber (string, optional): 手机号码，仅微信注册非必传 ,
nickname (string, optional): 用户昵称 ,
openid (string, optional): 普通用户的标识，对当前开发者帐号唯一 ,
privilege (Array[string], optional): 用户特权信息，json数组，如微信沃卡用户为（chinaunicom） ,
province (string, optional): 普通用户个人资料填写的省份 ,
registerInviteCode (string, optional): 邀请码 ,
sex (integer, optional): 普通用户性别，1为男性，2为女性 ,
smsCode (string, optional): 验证码，仅微信注册不用传 ,
unionid (string): 用户统一标识。针对一个微信开放平台帐号下的应用，同一用户的unionid是唯一的。 ,
wxCase (integer, optional): 1:原公众号 2：2号配置公众号
}
* */

//微信注册后，单独绑定手机号
export function wxBinPhone(data) {
  return request({
    url: '/api/auth/v3/user/register/binPhone',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
mobileNumber (string, optional): 手机号码 ,
smsCode (string, optional): 验证码 ,
openid (string, optional): 绑定手机/微信时必传openid ,
wxCase (integer, optional): 1:原公众号 2：2号配置公众号 ,

loginType (string, optional): 登录方式：MOBLIE、WECHAT、QQ、EMAIL = ['MOBLIE', 'WECHAT', 'QQ', 'EMAIL'],
wxCode (string, optional): 微信code
}
* */



// 登录(手机号登录)
export function userLogin(data) {
  return request({
    url: '/api/auth/v3/user/login',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
loginType (string): 登录方式：MOBLIE、WECHAT、QQ、EMAIL = ['MOBLIE', 'WECHAT', 'QQ', 'EMAIL'],
mobileNumber (string, optional): 手机号码 ,
smsCode (string, optional): 验证码 ,
wxCode (string, optional): 微信code
}
* */







// 以下为 注册时绑定 邀请关系 相关的接口/////////////////////////////////////////////////////

// 邀请注册，邀请码 与 微信 进行绑定，（只绑定，uc未生成 user）
export function getWebAuthorize(data) {
  return request({
    url: '/api/app/weixinmp/getWebAuthorize',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
code (string): 获取网页授权的code ,
state (string): 获取网页授权的state ,（实际为邀请码）
tid (string, optional): 注册后需要默认加入的群号，非必传
}
* */



// 根据邀请码查询用户信息
export function getUserByUserInfo(data) {
  return request({
    url: '/api/polk1/v2/user/getUserByUserInfo',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
inviteCode (string, optional): 邀请码，此字段不为空的时候以此查询 ,
mobilePhone (string, optional): 手机号 ,
openId (string, optional): openid ,
userName (string, optional): 用户名
}
* */



// 邀请注册，邀请码 与 微信 进行绑定，（只绑定，uc未生成 user）
export function phoneBindInviteCode(data) {
  return request({
    url: '/api/polk1/v2/bindPhone',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
mobileNumber (string): 手机号码 ,
registerinvitecode (string): 邀请码 ,
smsCode (string): 验证码 ,
tid (string, optional): 注册后需要默认加入的群号，非必传
}
* */








//请求绑定微信和手机号码------2019.10.28 废弃
export function bindWeiXin(data) {
  return request({
    url: '/api/auth/v3/user/bindWeiXin',
    method: 'post',
    baseURL,
    data
  })
}
/*
 {
city (string, optional): 普通用户个人资料填写的城市 ,
country (string, optional): 国家，如中国为CN ,
headimgurl (string, optional): 用户头像，最后一个数值代表正方形头像大小（有0、46、64、96、132数值可选，0代表640*640正方形头像），用户没有头像时该项为空 ,
mobileNumber (string): 手机号码 ,
nickname (string, optional): 用户昵称 ,
openid (string, optional): 普通用户的标识，对当前开发者帐号唯一 ,
privilege (Array[string], optional): 用户特权信息，json数组，如微信沃卡用户为（chinaunicom） ,
province (string, optional): 普通用户个人资料填写的省份 ,
sex (integer, optional): 普通用户性别，1为男性，2为女性 ,
smsCode (string): 验证码 ,
unionid (string): 用户统一标识。针对一个微信开放平台帐号下的应用，同一用户的unionid是唯一的。
}
* */



// ------------------- 2022.01.04  -----------------------
export function newUserLogin(data) {
  return request({
    url: '/UserLogin/v1/login',
    method: 'post',
    baseURL,
    data
  })
}
export function newBindLoginAccount(data) {
  return request({
    url: '/UserLogin/v1/bindLoginAccount',
    method: 'post',
    baseURL,
    data
  })
}
export function newUserRegister(data) {
  return request({
    url: '/UserLogin/v1/register',
    method: 'post',
    baseURL,
    data
  })
}







